shopDataLayer = {
	header: {
		// search: {
		// 	placeholder: 'Hledat produkt',
		// 	buttonText: 'Hledej',
		// },
		// contact: {
		// 	call: {
		// 		image: '',
		// 		title: '',
		// 		number: '',
		// 	},
		// 	write: {
		// 		image: '',
		// 		title: '',
		// 		mail: '',
		// 	},
		// },
	},
	footer: {
		// newsletter: {
		// 	title: '',
		// 	subtitle: '',
		// 	placeholder: '',
		// 	buttonText: '',
		// },
		// navigation: {
		// 	more: 'Zobrazit další stránky',
		// },
		// categories: {
		// 	more: 'Zobrazit další kategorie',
		// },
		// signature: "Vytvořili <a href='https://www.webotvurci.cz/' target='_blank'>Webotvůrci</a> na platformě <a href='https://www.shoptetpremium.cz/' target='_blank'>Shoptet Premium</a>",
	},
	productDetail: {
		// parametersTop: [],
		// availabilityLabel: '',
		// buttonText: 'Koupit',
		// emptyDescription: '',
		// parametersTitle: '',
		// descriptionTitle: '',
		// hiddenParameters: [],
	},
	homepage: {
		filters: {
			categories: [
				{
					label: 'Kruhové potrubí',
					url: '/kruhove-potrubi/',
					filters: [{ id: 42, label: 'Průměr potrubí' }],
				},
				{
					label: 'D-Flex',
					// Skrytá kategorie /d-flex-2/ má kompletní hodnoty d1 — viditelná /d-flex/ jen průměry 75 a 90
					url: '/d-flex-2/',
					filters: [{ id: 42, label: 'Průměr potrubí' }],
				},
				{
					// Ploché potrubí zatím nemá v Shoptetu parametrické filtry —
					// tab se vykreslí bez selectů, IDs doplní Kolo po nastavení parametrů
					label: 'Ploché potrubí',
					url: '/ploche-potrubi-2/',
					filters: [],
				},
			],
		},
	},
};
